import { useQuery } from "react-query";
import { fetchOptOutStatus, SMS_QUERY_KEYS } from "@/services/sms";

/** Query hook for whether the patient has opted out of SMS. */
export function useOptOutStatus(patientId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(SMS_QUERY_KEYS.optOutStatus(patientId), function () {
    return fetchOptOutStatus(patientId);
  }, {
    enabled: Boolean(patientId) && enabled,
    staleTime: 0
  });
}